<template>
    <div v-show="isLoaded" class="dRitualHoney-container" v-observe-visibility="startAnimate">
        <div class="dRitualHoney-title">
            <h2 class="title" :class="{animate: animate}">Ritual del Servido</h2>
        </div>
        <img class="dRitualHoney-miel" v-observe-visibility="startAnimate" :src="miel" :class="{animate: animate}" alt="Miel">
        <div class="dFlex-container">
            <div class="dImagen Imagen-1" :class="{animate: animate}">
                <img class="" :src="paso1" alt="Paso 1">
            </div>
            <div class="dImagen Imagen-2" :class="{animate: animate}">
                <img class="" :src="paso2" alt="Paso 2">
            </div>
            <div class="dImagen Imagen-3" :class="{animate: animate}">
                <img class="" :src="paso3" alt="Paso 3">
            </div>
        </div>
    </div>
</template>

<script>
import miel from '@/assets/honey/MIELHONEY.png';
import paso1 from '@/assets/honey/1HONEY.png';
import paso2 from '@/assets/honey/2HONEY.png';
import paso3 from '@/assets/honey/3HONEY.png';
import { mapGetters } from "vuex";
import Bowser from "bowser";

export default {
    name: "D_RitualHoney",
    data() {
        return {
            miel,
            paso1,
            paso2,
            paso3,
            animate: false,
            isSafari: false,
        };
    },
    computed: {
        ...mapGetters(["isLoaded"]),
    },
    methods: {
        startAnimate(isVisible) {
            if(isVisible) {
                this.animate=true
            } 
        }
    },
    components: { },
    beforeMount() {
        const browser = Bowser.getParser(window.navigator.userAgent);
        if (browser.getBrowserName()=='Safari') {
            this.isSafari = true
        }
    }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/Honey/D_RitualHoney.scss";
</style>